/**
 * THE PHONE'S SEARCH + SELECT ROW (0.1.508) — the row under the band on a list tab that has no
 * Display bar to hold a Select chip and no band search (the phone band is title · count · the
 * Display pill, DESIGN.md §3 Band).
 *
 * Hoisted at its THIRD occurrence, the DRY rule's shape threshold: Reservations, Projects and Rack
 * location each gained the same two controls in one release (maintainer, 15 Sep 2026: "for mobile
 * there also needs to be a search box and select button ... the same for the projects tab and rack
 * tab"). The Items tab's own search row (`.items-head-row` + `.items-search`) is the shape this
 * borrows — same classes, so the glass, the height and the wrap are one CSS block — and the
 * Boxes tab's phone `Select` chip is the toggle (`chip` / `chip chip-on`, "Select" / "Done").
 *
 * The DESK does not use this: there the search is the band's (`.band-search`) and Select lives in
 * the Display bar, both standing rulings.
 */
export function ListSearchRow({
  value,
  onChange,
  placeholder,
  label,
  trailing,
}: {
  value: string;
  onChange: (next: string) => void;
  placeholder: string;
  /** The input's accessible name — "Search reservations", "Search projects", "Search racks". */
  label: string;
  /**
   * What sits right of the search — the "Clear selection" pill while rows are ticked (0.1.527).
   * The Select/Done toggle this row carried since 0.1.508 is gone: every list's checkboxes are
   * permanent now (maintainer, 2 Oct 2026), so there was nothing left for it to switch.
   */
  trailing?: React.ReactNode;
}): JSX.Element {
  return (
    <div className="items-head-row list-search-row">
      <input
        type="search"
        className="items-search"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {trailing}
    </div>
  );
}
